import { DocumentationViewItemType } from 'store/documentation/model/types';
import { DirectoryModel } from 'shared/domain/directory/directoryModel';
import { DocumentationModel } from 'shared/domain/documentation/documentationModel';

type ParsedRowId = {
  localId: string;
  type: string;
};

function parseRowId(rowId: string): ParsedRowId | null {
  const separatorIndex = rowId.lastIndexOf('_');
  if (separatorIndex <= 0 || separatorIndex >= rowId.length - 1) {
    return null;
  }

  return {
    localId: rowId.slice(0, separatorIndex),
    type: rowId.slice(separatorIndex + 1),
  };
}

export function getDirectoryRowId(directory: DirectoryModel): string {
  return `${directory.localId}_${DocumentationViewItemType.DIRECTORY}`;
}

export function getDocumentationRowId(documentation: DocumentationModel): string {
  return `${documentation.localId}_${DocumentationViewItemType.FILE}`;
}

export function getDirectoryLocalIdFromRowId(rowId: string): string | null {
  const parsed = parseRowId(rowId);
  if (!parsed) {
    return null;
  }

  return parsed.type === DocumentationViewItemType.DIRECTORY
    ? parsed.localId
    : null;
}

export function getDocumentationLocalIdFromRowId(
  rowId: string
): string | null {
  const parsed = parseRowId(rowId);
  if (!parsed) {
    return null;
  }

  return parsed.type === DocumentationViewItemType.FILE
    ? parsed.localId
    : null;
}
